import React from 'react';
import SectionHeading from '../ui/SectionHeading';
import { Check, Award, TrendingUp } from 'lucide-react';
import consultingImage from '@/assets/consulting-discovery-session.jpg';
const WhyChooseUs: React.FC = () => {
  const reasons = [
    {
      icon: <Award className="text-brand-teal" size={24} />,
      title: "Proven Business Workflow Understanding & AI Expertise",
      description: "Our team brings years of AI implementation experience specifically focused on small business growth."
    },
    {
      icon: <Check className="text-brand-teal" size={24} />,
      title: "Clear, Jargon-Free Communication",
      description: "No confusing techno-speak—just clear, actionable AI solutions explained in plain language."
    },
    {
      icon: <TrendingUp className="text-brand-teal" size={24} />,
      title: "Affordable & Scalable Solutions",
      description: "AI solutions that grow with your business, with flexible pricing options for businesses of all sizes."
    }
  ];
  
  return (
    <div className="section">
      <div className="section-inner">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          {/* Image Section */}
          <div className="relative">
            <div className="relative">
              <div className="absolute inset-0 bg-gradient-to-br from-brand-blue/20 to-brand-purple/20 rounded-lg"></div>
              <div className="glass-card overflow-hidden rounded-lg p-2 shadow-glass">
              <img 
                  src={consultingImage}
                  alt="ThinkTomorrow.AI consultants in a discovery session with a client at a boardroom table" 
                  className="w-full h-auto rounded-lg object-cover"
                />
              </div>
              {/* Decorative Element */}
              <div className="absolute -bottom-6 -right-6 w-32 h-32 bg-brand-purple/10 rounded-full blur-2xl"></div>
            </div>
          </div>
          
          {/* Content Section */}
          <div>
            <SectionHeading 
              title="Why Choose ThinkTomorrow.AI?"
              subtitle="We're committed to making AI accessible, understandable, and valuable for every business."
              gradient
            />
            
            <div className="space-y-6">
              {reasons.map((reason, index) => (
                <div key={index} className="flex">
                  <div className="mt-1 mr-4">
                    <div className="w-10 h-10 rounded-full bg-brand-teal/10 flex items-center justify-center">
                      {reason.icon}
                    </div>
                  </div>
                  <div>
                    <h3 className="text-xl font-ibm mb-2">{reason.title}</h3>
                    <p className="text-gray-600">{reason.description}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default WhyChooseUs;
